import Average from "./Average"
import Students from "./Students"
import classes from "./HotMapTable.module.css"
import { useSelector } from "react-redux";

const HotMapTable = ({ studentsSubmmissionList }) => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);

    return (
        <>
            {studentsSubmmissionList.students && studentsSubmmissionList.students.length > 0 ?
                <div  className={`${classes.StudentsLayout}  ${classes[direction]}`} >
                    <div className={classes.AssessmentList}>
                        <div className={classes.AssessmentNameText}>
                        </div>
                        <div className={classes.AssessmentNameWrap} >
                            {studentsSubmmissionList.assessments.length ? <div className={`${classes.AssessmentName} ${classes.AssessmentGrade}`}>{texts.average}</div> : null}
                        </div>
                        {studentsSubmmissionList.assessments?.length ? studentsSubmmissionList.assessments.map((a, index) =>
                            <div className={classes.AssessmentNameWrap} key={index}>
                                <div className={classes.AssessmentName}> <span> {`${a.name == "Learning" || a.name == "Final" ? texts[a.name] : a.name}`}  </span> </div>
                            </div>
                        ) : null}
                    </div>
                    <Average averageList={studentsSubmmissionList.assessments}></Average>
                    <Students studentsScore={studentsSubmmissionList.students} assessmentsList={studentsSubmmissionList.assessments} ></Students>
                </div>
                :
                <div className={classes.Message}>{texts.NoAssessmentsFound}</div>}
        </>
    )
}
export default HotMapTable